import useMountEffect from '@restart/hooks/useMountEffect';

import EventEmitter from '@/libs/EventEmitter';
import telemetryStore from '@/stores/telemetryStore';

const useShecoTelemetryHandler = (robot) => {
  useMountEffect(() => {
    const subscribeToken = EventEmitter.subscribe(`${robot.id}/telemetry/mavlink`, clarifyMavLink);

    return () => {
      EventEmitter.unsubscribe(subscribeToken);
    };
  });

  const clarifyMavLink = ({ header, payload }) => {
    const msgId = header.msgid;

    switch (msgId) {
      case 1101: // USV_DATA
        storeTelemetry(msgId, payload);
        break;

      default:
        break;
    }
  };

  const storeTelemetry = (msgId, data) => {
    telemetryStore.set(robot.id, msgId, data);
  };
};

export default useShecoTelemetryHandler;
